export default {
  FETCH_REJECTED_BUSINESS_PARTNERS: "FETCH_REJECTED_BUSINESS_PARTNERS",
  FETCH_REJECTED_BUSINESS_PARTNERS_SUCCEEDED:
    "FETCH_REJECTED_BUSINESS_PARTNERS_SUCCEEDED",
};